import { Divider, Paper, Typography } from '@mui/material';
import * as React from 'react';
import { dateformat } from '../../../../../../helpers';

const InfoActividadExtra = ({ activo }) => {
  return (
    <Paper elevation={4} sx={{ p: 2 }}>
      <Typography
        textAlign="center"
        sx={{ fontSize: '16pt', fontWeight: 'bold' }}
      >
        {activo.instrumento?.nombre ?? '-'}
      </Typography>
      <Typography textAlign="center">{activo.tipo}</Typography>
      <Divider sx={{ my: 1 }} />
      <Typography>
        <strong>Ponderación: </strong>
        {activo.ponderacion}
      </Typography>
      <Typography>
        <strong>Fecha de inicio: </strong>
        {dateformat(activo.fechaInicio, { inverse: true })}
      </Typography>
      {activo.tipo === 'RECUPERACION' && (
        <Typography>
          <strong>Actividad remplazada: </strong>
          {activo.ptevaInstrumento?.instrumento?.nombre ?? '-'}
        </Typography>
      )}
    </Paper>
  );
};

export default InfoActividadExtra;
